import React from "react";

/**
 * Reusable Password Strength Checklist Component
 * Strictly styled using existing HMIS CSS / SCSS (_auth_flows.scss).
 *
 * @param {Object} props
 * @param {Object} props.rules - Result from checkPasswordRules(password, userContext)
 * @param {string} [props.title="Password must contain:"] - Optional title header
 */
const PasswordStrengthChecklist = ({ rules, title = "Password must contain:" }) => {
  if (!rules) return null;

  const items = [
    { label: "At least 12 characters (max 128)", met: !!rules.minLength },
    { label: "One uppercase letter (A-Z)", met: !!rules.hasUpper },
    { label: "One lowercase letter (a-z)", met: !!rules.hasLower },
    { label: "One number (0-9)", met: !!rules.hasNumber },
    { label: "One special character (!@#$%...)", met: !!rules.hasSpecial },
    { label: "No personal info (name, email, phone)", met: !!rules.noPersonalInfo },
    {
      label: "No common words or 4+ sequential runs (1234, abcd, aaaa)",
      met: !!rules.noCommonOrSequential,
    },
  ];

  return (
    <div className="password-checklist">
      {title && <div className="checklist-title">{title}</div>}
      <ul>
        {items.map((item, idx) => (
          <li key={idx} className={item.met ? "valid" : "invalid"}>
            <i className="material-icons">
              {item.met ? "check_circle" : "radio_button_unchecked"}
            </i>
            <span>{item.label}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PasswordStrengthChecklist;
